/* Match Import/Reports locally; diagnostic subpages keep their own width. */
.system-config-page {
  max-width: 1344px;
  grid-template-columns: minmax(0, 1fr);
  container: system-config / inline-size;
}

.system-config-page .system-config-hero {
  position: relative;
  isolation: isolate;
  min-height: 72px;
  padding: 6px 20px;
  overflow: clip;
  border: 1px solid var(--color-line-soft);
  border-radius: 4px;
  background: white;
}

.system-config-page .system-config-hero::before {
  position: absolute;
  z-index: -1;
  inset: 0 0 0 auto;
  width: 54%;
  max-width: 434px;
  content: "";
  background-image: url("/brand/reports/transia-grain-banner.png");
  background-position: right center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  mask-image: linear-gradient(90deg, transparent 10%, rgb(0 0 0 / 0.025) 18%, rgb(0 0 0 / 0.10) 26%, rgb(0 0 0 / 0.30) 34%, rgb(0 0 0 / 0.60) 42%, rgb(0 0 0 / 0.86) 48%, black 56%);
}

.system-config-page .system-config-hero > div {
  align-items: center;
  padding-right: clamp(330px, 32cqw, 440px);
}

.system-config-page .system-config-hero h1 {
  font-size: clamp(24px, 2.2cqw, 28px);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.035em;
}

.system-config-page .system-config-hero [aria-hidden='true']:has(> svg) {
  width: 32px;
  height: 32px;
}

.system-config-page .system-config-hero [aria-hidden='true'] > svg {
  width: 20px;
  height: 20px;
}

.system-config-page .system-config-hero-subtitle {
  display: block;
  margin-top: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--color-slate-800);
}

@media (max-width: 979px) {
  .system-config-page .system-config-hero {
    min-height: 0;
    padding: 12px 16px;
  }

  .system-config-page .system-config-hero::before {
    display: none;
    background-image: none;
  }

  .system-config-page .system-config-hero > div {
    padding-right: 0;
  }
}

@container system-config (max-width: 719px) {
  .system-config-page .system-config-hero [aria-hidden='true']:has(> svg) {
    width: 40px;
    height: 40px;
  }

  .system-config-page .system-config-hero-subtitle {
    font-size: 15px;
  }
}
